export { default } from './svg/ticket.svg';
